import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class XDockStatistics {
  id: string;
  name: string;
  desi: number;
  adet: number;
  hidden: number;
  create_date: Date;
  up_date: Date;
  point_id: number;
}

export class IXDockStatisticsResponse {
  @Type(() => XDockStatistics)
  result: XDockStatistics;
}

export class IXDockStatisticsListResponse extends IPagination {
  @Type(() => XDockStatistics)
  results: XDockStatistics[];
}

export class IXDockStatisticsQueryDto extends IQueryPaginationDto {}
